const props = {
  /** the collapsible is opened or not  */
  active: Boolean,
  /** the collapsing is vertical */
  vertical: Boolean,
  /** the collapsing is horizontal */
  horizontal: Boolean,
};

export default props;
